var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"justify-center text-h4 font-weight-light my-1"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }